import { PureComponent, ReactNode } from 'react';

import * as styles from '../styles';

export type StickyHeaderProps = {
  offset: number;
  topOffset?: number;
  children: ReactNode;
};

export default class StickyHeader extends PureComponent<StickyHeaderProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    offset: 0,
    topOffset: 0,
    children: null,
  };

  render(): JSX.Element {
    const { offset, topOffset } = this.props;

    return (
      // a11y (screen readers): We intentionally hide the sticky header from screen readers (set aria-hidden="true")
      // because screen readers don’t need a sticky header and the same content is already on the page for them
      // to interact with (e.g. merge button, etc.)
      <styles.StickyHeaderContent
        id="sticky-header-content"
        offset={offset}
        topOffset={topOffset || 0}
        aria-hidden="true"
      >
        {this.props.children}
      </styles.StickyHeaderContent>
    );
  }
}
